"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webRtcConnectionStatus_service_1 = require("xchelper/services/webRtcConnectionStatus.service");
const LABEL_KEYS = {
    [webRtcConnectionStatus_service_1.WEBRTC_STATE.CONNECTING]: "WEBRTC_CONNECTING",
    [webRtcConnectionStatus_service_1.WEBRTC_STATE.CONNECTED]: "WEBRTC_CONNECTED",
    [webRtcConnectionStatus_service_1.WEBRTC_STATE.ERROR]: "WEBRTC_ERROR",
};
class WebrtcConnectionStatus {
    constructor(webRtcConnectionStatus) {
        this.webRtcConnectionStatus = webRtcConnectionStatus;
        this.restrict = "E";
        this.scope = {};
        this.templateUrl = "assets/javascripts/xchelper/directives/webrtcConnectionStatus.html";
        this.link = (scope) => {
            const s = scope;
            const update = () => {
                s.status = this.webRtcConnectionStatus.getStatus();
                s.visible = this.webRtcConnectionStatus.isVisible();
                s.label = LABEL_KEYS[s.status] || "";
            };
            update();
            scope.$on(webRtcConnectionStatus_service_1.WEBRTC_CONNECTION_STATUS_CHANGED, update);
        };
    }
}
exports.default = WebrtcConnectionStatus;
WebrtcConnectionStatus.$inject = ["WebRtcConnectionStatus"];
